import { render, staticRenderFns } from "./ASide.vue?vue&type=template&id=72df1c46&scoped=true"
import script from "./ASide.vue?vue&type=script&lang=js"
export * from "./ASide.vue?vue&type=script&lang=js"
import style0 from "./ASide.vue?vue&type=style&index=0&id=72df1c46&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72df1c46",
  null
  
)

export default component.exports